(function(){
  if(window.__hvSn)return;window.__hvSn=1;
  function skip(r){return r.hidden||r.classList.contains('removing')||r.classList.contains('hvx-hide')||r.style.display==='none'||r.getAttribute('data-v')==='67728638738660'||/export-quality-upgrade/.test(r.getAttribute('data-h')||'')}
  function number(rows,host){var groups=[];rows.forEach(function(r){var p=r.parentNode;if(p&&groups.indexOf(p)<0)groups.push(p)});
    groups.forEach(function(p){var n=0;[].forEach.call(p.children,function(r){if(rows.indexOf(r)<0)return;
      var h=host(r);if(!h)return;var b=h.querySelector(':scope > .hv-sn');
      if(skip(r)){if(b)b.remove();return}n++;
      if(!b){b=document.createElement('span');b.className='hv-sn';b.setAttribute('aria-hidden','true');h.appendChild(b)}
      var t=String(n);if(b.textContent!==t)b.textContent=t})})}
  function run(){
    number([].slice.call(document.querySelectorAll('.cart-items__table-row')),function(r){return r.querySelector('.cart-items__media')});
    number([].slice.call(document.querySelectorAll('.hvo-li')),function(r){return r});
  }
  function start(){run();try{var q=0;new MutationObserver(function(){if(q)return;q=setTimeout(function(){q=0;run()},150)}).observe(document.body,{childList:true,subtree:true})}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
